"use client";

import { useRef } from "react";
import { useDateSegment } from "react-aria";
import { DateFieldState, DateSegment as IDateSegment } from "react-stately";
import { cn } from "@/lib/utils";

interface DateSegmentProps {
  segment: IDateSegment;
  state: DateFieldState;
}

function DateSegment({ segment, state }: DateSegmentProps) {
  const ref = useRef(null);

  const {
    segmentProps: { ...segmentProps },
  } = useDateSegment(segment, state, ref);

  return (
    <div
      {...segmentProps}
      ref={ref}
      className={cn(
        "rounded-sm py-0.5 text-base text-slate-900 focus:bg-primary/10 focus:text-primary focus:outline-hidden sm:text-sm",
        segment.type !== "literal" ? "px-[1px]" : "",
        segment.isPlaceholder && "text-slate-500",
        state.isDisabled && "text-slate-400",
      )}
    >
      {segment.text}
    </div>
  );
}

export { DateSegment };
